import { VariableType } from 'json-to-graphql-query';
import { Resource } from './resource';
/**
 * Historia
 *
 * @export
 * @class ClientHistoryResource
 * @extends {Resource}
 */
export class HistoryResource extends Resource {
    async list(filters) {
        const query = this.prepareOptions({
            query: {
                __variables: { filters: 'HistoryFilters' },
                history: {
                    count: true,
                    __args: {
                        filters: new VariableType('filters')
                    },
                    list: {
                        id: true,
                        created: true,
                        modified: true,
                        userId: true,
                        tableName: true,
                        entityId: true,
                        changes: true,
                        json: true,
                        action: true,
                        value: true,
                        profile: {
                            firstName: true,
                            lastName: true,
                            type: true,
                            partner: {
                                id: true
                            }
                        }
                    }
                }
            }
        });
        const data = await this.query({
            query,
            variables: { filters }
        }, 'history');
        return data;
    }
}
export const historyResource = new HistoryResource();
//# sourceMappingURL=clientHistory.resource.js.map